/* override functions api.jquery.js */

Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.shoppingcart-box .list');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  $('#popup-box-errors .text').text(str);
  $.fancybox.open("#popup-box-errors");
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    beforeSend: function() {
      showPreloader();
    },
    success: function(line_item) {
      hidePreloader();
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      hidePreloader();
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      beforeSend: function() {
        showPreloader();
      },
      success: function(line_item) {
        hidePreloader();
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          Shopify.cartPopapForm(variant_id);
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        hidePreloader();
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  if ($("#popup-box-cart").length > 0) {
    var imgholder = $('.'+variant_id+':first .preview-image');
    var title = $('.'+variant_id+':first .title').text();
    updateCartPopupBox(imgholder, title);
  }
}

Shopify.cartPopapForm = function(product_id) {
  if ($("#popup-box-cart").length > 0) {
    var imgholder = $('.'+product_id+':first .large-image');//.attr('src');
    var title = $('.'+product_id+':first .box-content h2').text();
    updateCartPopupBox(imgholder, title);
  }
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  
  var formatMoney = "<span class='money'>${{amount}}</span>";
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();

      jQuery.each(cart, function(key, value) {
        if (key === 'items') {

          if (value.length) {
            $(".cart-group-1").css({"display": "block"});
            $(".cart-group-2").css({"display": "none"});
            var table = jQuery(cart_cell_id + '.list');
            jQuery.each(value, function(i, item) {						
              if(i > 2){
                  return false;
              }
              jQuery('<li class="item"><a href="' + item.url + '" class="preview-image"><img class="preview" src="' + item.image + '" alt="' + item.title + '"></a><div class="icon-product-delete"><a href="javascript:;" onclick="Shopify.removeItem(' + item.variant_id + ')" title="Remove This Item" class="icon icon-trash-2" ></a></div><div class="description"><a href="' + item.url + '">' + item.title + '</a> <strong class="price">' + item.quantity + ' x ' + Shopify.formatMoney(item.price, formatMoney) + '</strong></div></li>').appendTo(table);
            });

          }
          else {
            $(".cart-group-1").css({"display": "none"});
            $(".cart-group-2").css({"display": "block"});
          }
        }
      });
    }
  }

  changeHtmlValue(".compact-hidden .cart_list_total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".total .cart_list_total", Shopify.formatMoney(cart.total_price, formatMoney));
  changeHtmlValue(".icon-xcart-animate .box", cart.item_count);
  changeHtmlValue(".icon-xcart-white", cart.item_count);

  $('.currencies .selected').trigger('click');
  $(".cart-text").trigger( "cartHandler", [ cart.item_count ] );
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = $(cell);
  $cartLinkText.html(value);
};
function updateCartPopupBox(imgholder, title) {
  if(title == "") {
    $('#popup-box-cart .small-content').show();
    $('#popup-box-cart .full-content').hide();
  }
  else {
    var img = $(imgholder).find('img');
    var url = img.length > 1 ? img.last().attr('src') : img.attr('src');
    $('#popup-box-cart .product-img img').attr('src', url);
    $('#popup-box-cart .popup-title').text(title);
    $('#popup-box-cart .small-content').hide();
    $('#popup-box-cart .full-content').show();
  }
  $.fancybox.open("#popup-box-cart");
}
function showPreloader() {
  $(".custom-loader").show();
}
function hidePreloader() {
  $(".custom-loader").hide();
}